import React,{useEffect, useState} from "react";

const  CounterBtn = props  =>{

    let counter = React.createRef();
    const [counterValue,setCounter] = useState(1)
    useEffect(()=>{
        let value = counter.current.value; 
        setCounter(value)
    },[])
    const onIncrement =  ()=>{   
        try{ 
            let id = props.productId+"counter"
            // let value = counter.current.value;
            let el = document.getElementById(id);
            let value = el.value; 
            if(props.runOnCounterUpdate){  
                 props.runOnCounterUpdate("increment",id).then(()=>{
                    if(value<props.stock){ 
                        // counter.current.value = parseInt(value) +1;
                        el.value = parseInt(value) +1;
                        // setCounter(counter.current.value)
                        setCounter(document.getElementById(id).value)
                    }
                 }).catch(error=>{
                    console.log("Some problem")
                 })
                
                 
            }else{
     
                if(value<props.stock){ 
                    // counter.current.value = parseInt(value) +1;
                    el.value = parseInt(value) +1;
                    setCounter(document.getElementById(id).value)
                }
            }
            
        }catch(error){
            return alert(error)
        }
          
    }

  
    const onDecrement = async()=>{

        try{
            let id = props.productId+"counter"
            // let value = counter.current.value;
            let el = document.getElementById(id);
            let value = el.value;
            if(props.runOnCounterUpdate){
                await props.runOnCounterUpdate("decrement",id);
                if(value>1){
                    // counter.current.value = parseInt(value) - 1;
                    el.value = parseInt(value) +1;
                    setCounter(document.getElementById(id).value)
                }
            }else{
                if(value>1){
                    
                    // counter.current.value = parseInt(value) - 1;
                    el.value = parseInt(value) -1;
                    setCounter(document.getElementById(id).value)
                } 
            }
        }catch(error){
            return alert(error)
        }
    
        
    } 

    // console.log(props.productId)
    return( 
        <div className="form-group col-7  col-md-3" style={{height:"33px",display:"flex"}}>

                                
        <button 
            className="btn btn-outline-secondary btn-sm"  
            type="button" onClick={onDecrement} 
            disabled={counterValue==1 || props.disabled}
        > <i className="fa fa-minus" aria-hidden="true"></i>
        </button>
        <input 
            className="form-control text-center bg-white form-control-sm" 
            type="number" 
            disabled 
            defaultValue={props.defaultValue?props.defaultValue:1} 
            ref={counter} 
            id={props.productId+"counter"}
            min={1} 
            max={props.stock} 
            style={{height:"100%",width:"60px"}}
        />
        <button className="btn btn-outline-secondary btn-sm"  type="button" onClick={onIncrement} disabled={counterValue==props.stock || props.disabled} 
           
        > <i className="fa fa-plus" aria-hidden="true"></i></button>
    

    </div>
    )
} 

export default CounterBtn; 